import { useEffect, useState } from "react";
import { MechanicsConfiguration } from "../models/mechanicsConfiguration.ts";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useDxf = (payload: MechanicsConfiguration) => {
  const [content, setContent] = useState<string>("");
  const { handle } = useMessageHandler();

  useEffect(() => {
    if (!payload) return;
    handle(async () => {
      const response = await apiJson.post("/mechanics/dxf/stack_top", payload, {
        responseType: "blob",
      });
      const text = await response.data.text();
      setContent(text);
    });
  }, [payload]);

  return { content };
};